import React, { memo } from 'react';
import cn from 'classnames';
import { Grid } from 'src/components/HTKit/Grid';
import Icon from 'src/components/HTKit/Icon';
import { PanelV2 } from 'src/components/HTKit/Elements/PanelV2';
import PropTypes from 'prop-types';
import styles from './styles.scss';

const ProductFeatures = ({ data = [], className }) => {
  return (
    <section className={styles.container}>
      <Grid.Fluid classes={className}>
        <Grid.Row>
          <Grid.Column sm={4} md={8} lg={8} lgOffset={2}>
            <Grid.Row classes={cn('marginBottom-medium', styles.header)}>
              <h4>Features</h4>
            </Grid.Row>
            <Grid.Row>
              {data.map((feature) => (
                <Grid.Column sm={4} md={8} lg={6} key={feature.id}>
                  <PanelV2
                    mediumBorderRadius
                    className={cn('padding-small1 marginBottom-small1', styles.panel)}
                  >
                    <div className={styles.iconContainer}>
                      <Icon name="checkmark-v2" className={styles.icon} />
                      <div className="marginLeft-small">
                        <h5>{feature.title}</h5>
                        <p className="p1 n700 paddingTop-tiny">{feature.description}</p>
                      </div>
                    </div>
                  </PanelV2>
                </Grid.Column>
              ))}
            </Grid.Row>
          </Grid.Column>
        </Grid.Row>
      </Grid.Fluid>
    </section>
  );
};

ProductFeatures.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      title: PropTypes.string,
      description: PropTypes.string,
    }),
  ),
  className: PropTypes.string,
};

export default memo(ProductFeatures);
